import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useStandardAlertStore } from '../../shared/store/portal/alertStore';
import { BlackFitBtn, PaperBlurFitBtn } from '../../shared/component/headless/button/BtnBody';
import { getBtnName } from '../../shared/constants/btnNames';
import { MediumIcon } from '../../shared/component/IconBody';
import logo from '../../asset/gnb/logo_fit.png';
import { paperTextureAlert } from '../../shared/component/paperTexture';


const ConfirmComp: React.FC = () => {
  const {
    queue,
    isClosing,
    isExecuting,
    executeCurrent,
    cancelCurrent,
  } = useStandardAlertStore();
  const alertRef = useRef<HTMLDivElement>(null);
  const currentStandardAlert = queue[0];

  useEffect(() => {
    if (alertRef.current) {
      alertRef.current.focus();
    }
  }, []);

  if (queue.length === 0) return null;

  const handleKeyDown = (event: React.KeyboardEvent) => {
    event.stopPropagation();
    if (event.key === 'Escape') {
      event.preventDefault();
      cancelCurrent();
      return;
    }
    if (event.target !== event.currentTarget) return;

    if (event.key !== 'Enter') return;
    event.preventDefault();
    cancelCurrent();
  };

  return (
    <ConfirmContent ref={alertRef} onKeyDown={handleKeyDown} tabIndex={-1}>
      <ConfirmHeader>
        <MediumIcon src={logo} alt='logo icon' />
      </ConfirmHeader>
      <Content>{currentStandardAlert.content}</Content>
      <ButtonContainer>
        {currentStandardAlert.callBack ?
          <>
            <BlackFitBtn
              disabled={isClosing || isExecuting}
              onClick={() => void executeCurrent()}
            >
              {getBtnName('OK')}
            </BlackFitBtn>
            <PaperBlurFitBtn
              disabled={isClosing || isExecuting}
              onClick={cancelCurrent}
            >
              {getBtnName('CANCEL')}
            </PaperBlurFitBtn>
          </>
          :
          <BlackFitBtn
            disabled={isClosing || isExecuting}
            onClick={cancelCurrent}
          >
            {getBtnName('OK')}
          </BlackFitBtn>
        }
      </ButtonContainer>
    </ConfirmContent>
  );
};

const ConfirmHeader = styled.div`
  margin-bottom: 12px;
  user-select: none;
`;

const Content = styled.div`
  margin-bottom: 44px;
  white-space: pre-line;
  line-height: 20px;
  ${({ theme }) => theme.typography.Body_03_2};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5vw;
`;

const ConfirmContent = styled.div`
  position: fixed;
  top: calc(10vh);
  left: 50%;
  transform: translateX(-50%);
  min-width: 500px;
  min-height: 50px;
  width: fit-content;
  height: fit-content;
  outline: none;
  padding: 20px;

  ${paperTextureAlert}
  background-color: ${({ theme }) => theme.colors.color_White};
`;

export default ConfirmComp;
